module.exports = __webpack_public_path__ + "img/piston.9beb53df.png";